function handleUpcartToggle(retryCount = 0, maxRetries = 20) {
  setTimeout(() => {
    const shadowHosts = document.querySelectorAll('*');
    let toggleSwitch = null;
    
    for (let host of shadowHosts) {
      if (host.shadowRoot) {
        toggleSwitch = host.shadowRoot.querySelector('.upcart-internal-addons__toggle-switch input[type="checkbox"]');
        
        if (!toggleSwitch) {
          toggleSwitch = host.shadowRoot.querySelector('.upcart-public-addons__toggle-switch input[type="checkbox"]');
        }
        
        if (!toggleSwitch) {
          toggleSwitch = host.shadowRoot.querySelector('input[role="switch"]');
        }
        
        if (toggleSwitch) break;
      }
    }
    
    if (toggleSwitch) {
      const isChecked = toggleSwitch.getAttribute('aria-checked') === 'true';
      
      if (!isChecked) {
        const label = toggleSwitch.closest('label');
        if (label) {
          label.click();
        } else {
          toggleSwitch.click();
        }
      }
    } else {
      if (retryCount < maxRetries) {
        handleUpcartToggle(retryCount + 1, maxRetries);
      }
    }
  }, retryCount === 0 ? 500 : 200);
}

window.addEventListener('aftersell-upcart:public-events:cart-opened', handleUpcartToggle);
document.addEventListener('DOMContentLoaded', handleUpcartToggle);